@for (state of getStateKeys(); track $index) {
  @if (!isStateEmpty(state) && value[state].show) {
    <div class="mt-3">
      <hr />
      <h5 class="">{{ "COMPONENTS.TILE.STATUSES." + state | translate }}</h5>
      @for (specialty of getSpecialtyKeys(state); track $index) {
        @if (getConsults(state, specialty).length > 0 && value[state].value[specialty].show) {
          <div class="m-2">
            <h6 class="d-flex align-items-center mt-2"><mat-icon>chevron_right</mat-icon> {{ specialty }}</h6>
            <app-table
              #requestTable
              id="REQUESTS"
              [storageId]="state + '-' + specialty"
              [data]="getConsults(state, specialty)"
              [pageSizes]="[10, 20, 50, 100]"
              [headers]="energyConsultListHeaders"
            ></app-table>
          </div>
        }
      }
    </div>
  }
}

<ng-template #noteColumnTemplate let-data="data">
  @if (data.extraProperties?.note?.length > 0 || data.message?.length > 0) {
    <mat-icon
      [matTooltip]="
        (data.message?.length > 0 ? ('COMPONENTS.DASHBOARD.NOTE_TOOLTIP_MESSAGE' | translate) + ': \n' + data.message + '\r\n' : '') +
        (data.extraProperties?.note?.length > 0 ? '\r\n' + ('TABLES.REQUESTS.NOTE' | translate) + ': \n' + data.extraProperties.note : '')
      "
      matTooltipClass="multiline-tooltip"
    >
      message</mat-icon
    >
  }
  <ng-container *appModule="'TIME_SLOTS_DAILY'">
    @if (getTimeslotDailyMessage(data)) {
      <mat-icon [matTooltip]="('COMPONENTS.TILE.TIME_SLOTS_DAILY' | translate) + ': \r\n' + getTimeslotDailyMessage(data)" matTooltipClass="multiline-tooltip"
        >perm_contact_calendar</mat-icon
      >
    }
  </ng-container>
</ng-template>
